// 纯数据提交传递
export const COMMIT_PURE_DATA = 'COMMIT_PURE_DATA'
// 清空纯数据对象
export const RESET_COMMIT_PURE_DATA = 'RESET_COMMIT_PURE_DATA'
// 操作当前数据
export const SET_ACTIVATED_DATA = 'SET_ACTIVATED_DATA'
// 设置keepalive includes 值
export const SET_KEEPALIVE_INCLUDES = 'SET_KEEPALIVE_INCLUDES'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js